var map = {
	"./ar.png": "./src/assets/img/lang/ar.png",
	"./bn.png": "./src/assets/img/lang/bn.png",
	"./cn.png": "./src/assets/img/lang/cn.png",
	"./en.png": "./src/assets/img/lang/en.png",
	"./es.png": "./src/assets/img/lang/es.png",
	"./fr.png": "./src/assets/img/lang/fr.png",
	"./hi.png": "./src/assets/img/lang/hi.png",
	"./hk.png": "./src/assets/img/lang/hk.png",
	"./id.png": "./src/assets/img/lang/id.png",
	"./ja.png": "./src/assets/img/lang/ja.png",
	"./kr.png": "./src/assets/img/lang/kr.png",
	"./pt.png": "./src/assets/img/lang/pt.png",
	"./th.png": "./src/assets/img/lang/th.png",
	"./vn.png": "./src/assets/img/lang/vn.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/lang sync recursive ^\\.\\/.*\\.png$";